import React from 'react';

import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import Loading, {Types} from '@pb/kit-component-loading';
import {Tooltip} from '@pb/kit-component-popups';

import type {Error} from 'src/openapi/admin/models/Error';

type Props = {
    isLoading: boolean,
    loadingError: Error | null,
};

export const HeaderPrefix = ({isLoading, loadingError}: Props) => {
    if (isLoading) {
        return <Loading type={Types.ICON}/>;
    }


    if (loadingError) {
        return (
            <Tooltip
                anchor={({anchorRef, getAnchorProps}) => (
                    <BasicIconButton ref={anchorRef} {...getAnchorProps()} iconProps={{type: Icons.ERROR}}/>
                )}>
                {loadingError.message}
            </Tooltip>
        );
    }

    return <div/>;
};
